import { Flex, Heading } from '@chakra-ui/react';
import { BusinessOverviewPeriod } from '@client/graphql/__generated__/types';
import { Select } from '~/services/document/common/Select';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { DATE_RANGE_OPTIONS } from './constants';
import { useOrganizationPipelineContext } from './OrganizationPipelineContext';

export const OrganizationPipelineHeader = () => {
  const { selectedOrganization } = useAppContext();
  const { selectedDateRange, setSelectedDateRange } =
    useOrganizationPipelineContext();

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      mb={2}
      width="100%"
    >
      <Heading size="xxs">{selectedOrganization?.name}</Heading>
      <Select
        // components={{ Control: CustomSelectControl }}
        isMulti={false}
        options={DATE_RANGE_OPTIONS}
        size="sm"
        value={DATE_RANGE_OPTIONS.find(
          (option) => option.value === selectedDateRange
        )}
        onChange={(value) => {
          setSelectedDateRange(value?.value as BusinessOverviewPeriod);
        }}
      />
    </Flex>
  );
};
